module.exports = __webpack_public_path__ + "img/mn.022fa0db.jpg";